import fetchCourse from './fetchCourse';
import fetchCourses from './fetchCourses';
import handleCourseEnd from './handleCourseEnd';

export default [
  fetchCourse,
  fetchCourses,
  handleCourseEnd,
];
